// Shared header runtime, loaded once by site-header.liquid. Markup and translated labels stay there.
// window.siteHeaderBootstrap.init() mounts the current header; shopify:section:load remounts editor replacements.
(function () {
    if (window.siteHeaderBootstrap) {
      window.siteHeaderBootstrap.init();
      return;
    }
    // Header 组件逻辑
    var siteHeader = {
      header: null,
      sectionWrapper: null,
      sectionRoot: null,
      mobileMenuButton: null,
      mobileNavDrawer: null,
      mobileSearchContent: null,
      mobileSearchDefaultStore: null,
      mobileSearchShowingResults: false,
      mobileSearchCache: {},
      mobileSearchCacheKeys: [],
      mobileSearchCacheLimit: 50,
      mobileSearchDebounceTimer: null,
      rotatingPlaceholderInterval: 3600,
      viewportFrame: null,

      init: function () {
        if (this.globalEvents && !this.globalEvents.signal.aborted) return;
        this.header = document.querySelector('.site-header[data-sticky-type]');
        this.sectionWrapper = this.header?.closest('[id^="shopify-section-"]') || null;
        this.sectionRoot = this.sectionWrapper ? this.sectionWrapper.querySelector('.sec__header') : null;
        this.mobileMenuButton = this.sectionRoot ? this.sectionRoot.querySelector('.site-header__menu-toggle') : null;
        this.mobileNavDrawer = document.getElementById('mobile-nav');
        this.mobileSearchDrawer = document.getElementById('mobile-search');
        if (!this.header || !this.sectionWrapper || !this.sectionRoot) return;

        this.globalEvents = new AbortController();
        var self = this;
        document.addEventListener('shopify:section:unload', function (event) {
          if (event.target === self.sectionWrapper || self.sectionWrapper.contains(event.target)) self.dispose();
        }, { signal: this.globalEvents.signal });

        this.applySpriteIcons();
        this.enhanceDesktopSearch();
        this.syncCartCountBadges();

        // 初始化 Mega Menu hover
        this.initMegaMenuHover();
        this.initMegaMenuPreviewHover();
        this.initDesktopActionHover();
        this.updateMobileNavOffset();
        this.updateMegaMenuAlignment();
        this.bindViewportEvents();
        this.bindMobileNavEvents();
        this.bindMobileSearchEvents();
        this.bindMobileTooltipEvents();

        // 注册 drawer
        if (window.themeDrawer) {
          window.themeDrawer.register('mobile-nav', {
            position: 'left',
            zIndex: 1052,
            lockBodyScroll: false,
            lockDocumentElementScroll: false,
          });

          window.themeDrawer.register('mobile-search', {
            position: 'right',
            zIndex: 1062,
            lockPageScroll: false,
          });
        }
      },

      dispose: function () {
        this.globalEvents?.abort();
        this.desktopSearchEvents?.abort();
        this.cancelDesktopSearchRequest();
        if (this.viewportFrame !== null) cancelAnimationFrame(this.viewportFrame);
        this.viewportFrame = null;
        window.clearTimeout(this.mobileSearchDebounceTimer);
        this.cartCountObserver?.disconnect();
        this.recentObservers?.forEach(function (observer) { observer.disconnect(); });
        this.recentObservers?.clear();
        [this.mobileSearchInput, this.desktopSearch?.input].forEach(function (input) {
          if (!input) return;
          window.clearInterval(input._themePlaceholderTimer);
          window.clearTimeout(input._themePlaceholderAnimationTimer);
          input._themePlaceholderTimer = null;
          input._themePlaceholderAnimationTimer = null;
        });
        document.documentElement.classList.remove('site-header-search-open');
        document.body.classList.remove('site-header-search-open');
        if (window.siteHeader === this) window.siteHeader = null;
      },

      updateMobileNavOffset: function () {
        if (!this.sectionWrapper || !this.sectionRoot || !this.header) return;

        var offsetTop = this.header.offsetHeight || 56;
        if (window.matchMedia('(max-width: 1279.98px)').matches) {
          offsetTop = Math.max(this.sectionWrapper.getBoundingClientRect().bottom, this.header.offsetHeight || 56);
        }

        this.sectionRoot.style.setProperty('--mobile-nav-offset-top', Math.round(offsetTop) + 'px');
      },

      updateMegaMenuAlignment: function () {
        if (!this.sectionRoot) return;

        var nav = this.sectionRoot.querySelector('.site-header__nav');
        var megaMenuWrapper = this.sectionRoot.querySelector('.site-header__mega-menu-wrapper');
        if (!nav || !megaMenuWrapper) return;

        var navRect = nav.getBoundingClientRect();
        var wrapperRect = megaMenuWrapper.getBoundingClientRect();
        if (navRect.width <= 0 || wrapperRect.width <= 0) return;

        var left = Math.max(16, Math.round(navRect.left - wrapperRect.left));
        var right = Math.max(16, Math.round(wrapperRect.right - navRect.right));

        megaMenuWrapper.style.setProperty('--mega-menu-content-left', left + 'px');
        megaMenuWrapper.style.setProperty('--mega-menu-content-right', right + 'px');
      },

      bindViewportEvents: function () {
        var self = this;

        function syncOffset() {
          if (self.viewportFrame !== null) return;
          self.viewportFrame = requestAnimationFrame(function () {
            self.viewportFrame = null;
            if (self.globalEvents.signal.aborted) return;
            self.updateMobileNavOffset();
            self.updateMegaMenuAlignment();
          });
        }

        // Close compact navigation when its trigger disappears on desktop.
        window.matchMedia('(min-width: 1280px)').addEventListener('change', function (event) {
          if (!event.matches) return;
          self.initDesktopActionHover();
          if (!window.themeDrawer) return;
          ['mobile-nav', 'mobile-search'].forEach(function (id) {
            if (window.themeDrawer.isOpen(id)) window.themeDrawer.close(id);
          });
        }, { signal: this.globalEvents.signal });
        window.addEventListener('resize', syncOffset, { signal: this.globalEvents.signal });
        window.addEventListener('orientationchange', syncOffset, { signal: this.globalEvents.signal });

      },

      bindMobileNavEvents: function () {
        var self = this;
        if (!this.mobileNavDrawer) return;

        this.mobileNavDrawer.addEventListener('theme-drawer:opened', function () {
          self.setMobileNavToggleState(true);
        });

        this.mobileNavDrawer.addEventListener('theme-drawer:closed', function () {
          self.setMobileNavToggleState(false);
        });
      },

      bindMobileSearchEvents: function () {
        var self = this;
        if (!this.mobileSearchDrawer) return;
        this.mobileSearchForm = this.mobileSearchDrawer.querySelector('.search-drawer-input-wrapper');
        this.mobileSearchInput = this.mobileSearchDrawer.querySelector('.search-drawer-input');
        this.mobileSearchClearBtn = this.mobileSearchDrawer.querySelector('.search-drawer-clear');
        this.mobileSearchScrollArea = this.mobileSearchDrawer.querySelector('.search-drawer-scrollable');
        this.mobileSearchContent = this.mobileSearchDrawer.querySelector('[data-mobile-search-content]');
        this.mobileSearchDefaultStore = document.createElement('div');

        if (!this.mobileSearchForm || !this.mobileSearchInput || !this.mobileSearchContent) {
          return;
        }

        this.initializeRotatingSearchPlaceholder(this.mobileSearchInput);
        this.bindMobileSearchScrollBoundary();

        // 清除按钮点击事件
        if (this.mobileSearchClearBtn) {
          this.mobileSearchClearBtn.addEventListener('click', function () {
            self.clearMobileSearch();
          });
        }

        this.mobileSearchForm.addEventListener('submit', function (event) {
          self.handleSearchFormSubmit(event, self.mobileSearchInput);
        }, true);

        this.mobileSearchInput.addEventListener('input', function () {
          self.handleMobileSearchChange();
          self.toggleMobileSearchClear();
        });

        this.mobileSearchInput.addEventListener('keyup', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            self.handleMobileSearchChange({ immediate: true });
          }
        });

        this.mobileSearchInput.addEventListener('search', function () {
          self.handleMobileSearchChange({ immediate: true });
          self.toggleMobileSearchClear();
        });

        this.mobileSearchInput.addEventListener('focus', function () {
          if (!self.getMobileSearchQuery().length) return;
          self.handleMobileSearchChange({ immediate: true });
        });

        // 自动聚焦搜索框
        this.mobileSearchDrawer.addEventListener('theme-drawer:opened', function () {
          document.documentElement.classList.add('site-header-search-open');
          document.body.classList.add('site-header-search-open');

          setTimeout(function () {
            if (self.mobileSearchInput) {
              self.mobileSearchInput.focus();
              self.toggleMobileSearchClear();
              if (self.getMobileSearchQuery().length) {
                self.handleMobileSearchChange({ immediate: true });
              }
            }
          }, 350);

          self.preloadSearchRecentlyViewed();
        });

        this.mobileSearchDrawer.addEventListener('theme-drawer:closed', function () {
          document.documentElement.classList.remove('site-header-search-open');
          document.body.classList.remove('site-header-search-open');
        });
      },

      bindMobileSearchScrollBoundary: function () {
        if (!this.mobileSearchScrollArea || this.mobileSearchScrollArea.dataset.scrollBoundaryBound === 'true') return;

        var scrollArea = this.mobileSearchScrollArea;
        var touchStartY = 0;
        scrollArea.dataset.scrollBoundaryBound = 'true';

        scrollArea.addEventListener(
          'touchstart',
          function (event) {
            if (!event.touches || event.touches.length !== 1) return;
            touchStartY = event.touches[0].clientY;
          },
          { passive: true }
        );

        scrollArea.addEventListener(
          'touchmove',
          function (event) {
            if (!event.touches || event.touches.length !== 1) return;

            var currentY = event.touches[0].clientY;
            var deltaY = currentY - touchStartY;
            var maxScrollTop = scrollArea.scrollHeight - scrollArea.clientHeight;

            if (maxScrollTop <= 0) {
              event.preventDefault();
              return;
            }

            var isAtTop = scrollArea.scrollTop <= 0;
            var isAtBottom = scrollArea.scrollTop >= maxScrollTop - 1;

            if ((isAtTop && deltaY > 0) || (isAtBottom && deltaY < 0)) {
              event.preventDefault();
            }
          },
          { passive: false }
        );
      },

      bindMobileTooltipEvents: function () {
        var self = this;
        if (!this.sectionRoot) return;

        function shouldUseClickTooltips() {
          return (
            window.matchMedia('(max-width: 1279.98px)').matches ||
            window.matchMedia('(hover: none)').matches ||
            window.matchMedia('(pointer: coarse)').matches
          );
        }

        // 移动端 tooltip 点击触发
        this.sectionRoot.addEventListener('click', function (event) {
          var tooltipTrigger = event.target.closest('[data-tooltip] .site-tooltip__trigger button, [data-tooltip] .site-tooltip__trigger a');
          if (!tooltipTrigger) return;

          if (shouldUseClickTooltips()) {
            event.preventDefault();
            event.stopPropagation();

            var tooltipWrapper = tooltipTrigger.closest('[data-tooltip]');
            if (!tooltipWrapper) return;

            var isOpen = tooltipWrapper.classList.contains('is-open');

            self.sectionRoot.querySelectorAll('[data-tooltip].is-open').forEach(function (openTooltip) {
              if (openTooltip !== tooltipWrapper) {
                self.closeTooltip(openTooltip);
              }
            });

            if (isOpen) {
              self.closeTooltip(tooltipWrapper);
            } else {
              self.openTooltip(tooltipWrapper);
            }
          }
        });

        document.addEventListener('click', function (event) {
          if (!event.target.closest('[data-tooltip]')) {
            self.sectionRoot.querySelectorAll('[data-tooltip].is-open').forEach(function (tooltip) {
              self.closeTooltip(tooltip);
            });
          }
        }, { signal: this.globalEvents.signal });
      },

      openTooltip: function (tooltipWrapper) {
        if (!tooltipWrapper) return;
        tooltipWrapper.classList.add('is-open');
        var trigger = tooltipWrapper.querySelector('.site-tooltip__trigger button, .site-tooltip__trigger a');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'true');
        }
      },

      closeTooltip: function (tooltipWrapper) {
        if (!tooltipWrapper) return;
        tooltipWrapper.classList.remove('is-open');
        var trigger = tooltipWrapper.querySelector('.site-tooltip__trigger button, .site-tooltip__trigger a');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      },

      getMobileSearchQuery: function () {
        if (!this.mobileSearchInput) return '';
        return this.mobileSearchInput.value.trim();
      },

      clearMobileSearch: function () {
        if (!this.mobileSearchInput) return;

        this.mobileSearchInput.value = '';
        this.mobileSearchInput.focus();
        this.toggleMobileSearchClear();
        this.resetMobileSearchState(false);
      },

      toggleMobileSearchClear: function () {
        if (!this.mobileSearchClearBtn) return;

        var hasValue = this.getMobileSearchQuery().length > 0;
        this.mobileSearchClearBtn.hidden = !hasValue;
      },

      handleMobileSearchChange: function (options) {
        var self = this;
        var config = options || {};
        var searchTerm = this.getMobileSearchQuery();

        window.clearTimeout(this.mobileSearchDebounceTimer);

        if (!searchTerm.length) {
          this.resetMobileSearchState(false);
          return;
        }

        this.setMobileSearchLoadingState(true);

        if (config.immediate) {
          this.fetchMobileSearchResults(searchTerm);
          return;
        }

        this.mobileSearchDebounceTimer = window.setTimeout(function () {
          self.fetchMobileSearchResults(searchTerm);
        }, 180);
      },

      fetchMobileSearchResults: function (searchTerm) {
        var self = this;
        var cacheKey = searchTerm.toLowerCase();
        var predictiveSearchUrl = routes && routes.predictive_search_url ? routes.predictive_search_url : routes.search_url;
        var searchUrl = `${predictiveSearchUrl}?q=${encodeURIComponent(searchTerm)}&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[type]=query,product,page,article&resources[limit]=4&resources[limit_scope]=each&section_id=predictive-search-results`;

        this.setMobileSearchLoadingState(true);

        if (this.mobileSearchCache[cacheKey]) {
          this.renderMobileSearchResults(this.mobileSearchCache[cacheKey]);
          return;
        }

        // Enforce cache size limit
        if (this.mobileSearchCacheKeys.length >= this.mobileSearchCacheLimit) {
          var evictKey = this.mobileSearchCacheKeys.shift();
          delete this.mobileSearchCache[evictKey];
        }

        fetch(searchUrl)
          .then(function (response) {
            if (!response.ok) {
              throw new Error(response.status);
            }

            return response.text();
          })
          .then(function (text) {
            if (self.getMobileSearchQuery() !== searchTerm) return;

            var parsedDocument = new DOMParser().parseFromString(text, 'text/html');
            var section = parsedDocument.querySelector('#shopify-section-predictive-search-results');
            if (section) {
              parsedDocument.querySelectorAll('style[data-section-stylesheet]').forEach(function (style) {
                if (!section.contains(style)) section.prepend(style);
              });
            }
            var resultsMarkup = section ? section.innerHTML : parsedDocument.body.innerHTML;

            if (resultsMarkup && resultsMarkup.trim().length) {
              self.mobileSearchCache[cacheKey] = resultsMarkup;
              self.mobileSearchCacheKeys.push(cacheKey);
            }
            self.renderMobileSearchResults(resultsMarkup);
          })
          .catch(function () {
            self.resetMobileSearchState(false);
          });
      },

      renderMobileSearchResults: function (resultsMarkup) {
        if (!this.mobileSearchContent) return;

        if (!resultsMarkup || !resultsMarkup.trim().length) {
          this.resetMobileSearchState(false);
          return;
        }

        if (!this.mobileSearchShowingResults) {
          while (this.mobileSearchContent.firstChild) {
            this.mobileSearchDefaultStore.appendChild(this.mobileSearchContent.firstChild);
          }
          this.mobileSearchShowingResults = true;
        }

        this.mobileSearchContent.innerHTML = resultsMarkup;
        this.mobileSearchContent.classList.remove('search-drawer-default-content');
        this.mobileSearchContent.classList.add('search-drawer-predictive', 'predictive-search--header', 'results');

        if (this.mobileSearchScrollArea) {
          this.mobileSearchScrollArea.scrollTop = 0;
        }

        this.setMobileSearchLoadingState(false);
      },

      setMobileSearchLoadingState: function (isLoading) {
        if (!this.mobileSearchDrawer) return;
        this.mobileSearchDrawer.classList.toggle('is-loading', Boolean(isLoading));
      },

      preloadSearchRecentlyViewed: function () {
        var self = this;
        var preload = function () {
          self.initializeRecentlyViewedProducts(self.mobileSearchDrawer);
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(preload, { timeout: 1200 });
        } else {
          window.setTimeout(preload, 300);
        }
      },

      initializeRecentlyViewedProducts: function (scope) {
        if (!scope || !window.customElements || !window.customElements.whenDefined) return;

        window.customElements.whenDefined('recently-viewed-products').then(function () {
          scope.querySelectorAll('recently-viewed-products').forEach(function (element) {
            if (typeof element.initData === 'function') {
              element.initData();
            }
          });
        });
      },

      resetMobileSearchState: function (clearInput) {
        window.clearTimeout(this.mobileSearchDebounceTimer);

        if (clearInput && this.mobileSearchInput) {
          this.mobileSearchInput.value = '';
        }

        if (this.mobileSearchContent) {
          if (this.mobileSearchShowingResults) {
            this.mobileSearchContent.innerHTML = '';
            while (this.mobileSearchDefaultStore.firstChild) {
              this.mobileSearchContent.appendChild(this.mobileSearchDefaultStore.firstChild);
            }
          }

          this.mobileSearchContent.classList.remove('search-drawer-predictive', 'predictive-search--header', 'results');
          this.mobileSearchContent.classList.add('search-drawer-default-content');
        }

        this.mobileSearchShowingResults = false;
        this.setMobileSearchLoadingState(false);
      },

      setMobileNavToggleState: function (isOpen) {
        if (!this.mobileMenuButton) return;

        this.mobileMenuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        this.mobileMenuButton.setAttribute('aria-label', isOpen ? this.mobileMenuButton.dataset.menuCloseLabel : this.mobileMenuButton.dataset.menuOpenLabel);
      },

      toggleMobileNav: function () {
        if (!window.themeDrawer) return;

        this.updateMobileNavOffset();

        if (window.themeDrawer.isOpen('mobile-nav')) {
          window.themeDrawer.close('mobile-nav');
        } else {
          window.themeDrawer.open('mobile-nav');
        }
      },

      openMobileSearch: function () {
        if (!window.themeDrawer || !this.mobileSearchDrawer) return;
        window.themeDrawer.open('mobile-search');
      },

      closeMobileSearch: function () {
        if (!window.themeDrawer || !this.mobileSearchDrawer) return;
        this.resetMobileSearchState(true);
        window.themeDrawer.close('mobile-search');
      },

      applySpriteIcons: function () {
        var searchIcons = this.sectionRoot.querySelectorAll('.site-header__desktop-search .search__button svg');

        searchIcons.forEach(function (iconSvg) {
          iconSvg.setAttribute('class', 'site-header__icon-svg');
          iconSvg.setAttribute('width', '20');
          iconSvg.setAttribute('height', '20');
          iconSvg.innerHTML = '<use href="#ic-search"></use>';
        });
      },

      enhanceDesktopSearch: function () {
        var desktopSearch = this.sectionRoot.querySelector('.site-header__desktop-search');
        if (!desktopSearch) return;

        var popupSearch = desktopSearch.querySelector('.popup-search');
        var recentBlock = popupSearch ? popupSearch.querySelector('.search-suggest') : null;
        var mobileRecentBlock = this.mobileSearchDrawer
          ? this.mobileSearchDrawer.querySelector('.search-drawer-recently')
          : null;

        this.observeRecentlyViewedBlock(recentBlock);
        this.observeRecentlyViewedBlock(mobileRecentBlock);

        // 绑定PC端搜索清除按钮
        this.initDesktopPredictiveSearch();
        this.bindDesktopSearchClear();
      },

      // Desktop predictive search belongs to Header; all input/option state is scoped here.
      initDesktopPredictiveSearch: function () {
        var root = this.sectionRoot.querySelector('.site-header__desktop-search');
        var input = root?.querySelector('.search__input');
        var popup = root?.querySelector('.popup-search');
        var results = root?.querySelector('[data-predictive-search-content]');
        if (!input || !popup || !results) return;

        this.desktopSearchEvents?.abort();
        this.desktopSearchEvents = new AbortController();
        var options = { signal: this.desktopSearchEvents.signal };
        var self = this;
        this.desktopSearch = {
          root: root, input: input, popup: popup, results: results,
          form: input.form, predictive: root.querySelector('#predictive-search'),
          defaults: document.createDocumentFragment(), cache: new Map(),
          showingResults: false, requestId: 0, timer: null, request: null
        };

        input.addEventListener('focus', function () { self.refreshDesktopSearch(); }, options);
        input.addEventListener('input', function () {
          self.cancelDesktopSearchRequest();
          self.resetDesktopSearchSelection();
          if (!input.value.trim()) {
            self.restoreDesktopSearchDefaults();
            self.openDesktopSearch();
            return;
          }
          self.desktopSearch.timer = setTimeout(function () { self.refreshDesktopSearch(); }, 300);
        }, options);
        root.addEventListener('keydown', function (event) {
          if (event.isComposing) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            input.focus();
            self.closeDesktopSearch();
          } else if (event.target === input && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
            event.preventDefault();
            self.moveDesktopSearchSelection(event.key === 'ArrowDown' ? 1 : -1);
          }
        }, options);
        root.addEventListener('focusout', function (event) {
          if (!root.contains(event.relatedTarget)) self.closeDesktopSearch();
        }, options);
        document.addEventListener('pointerdown', function (event) {
          if (!root.contains(event.target)) self.closeDesktopSearch();
        }, options);
        document.addEventListener('shopify:section:unload', function (event) {
          if (!event.target.contains(root)) return;
          self.cancelDesktopSearchRequest();
          self.desktopSearchEvents.abort();
        }, options);
      },

      cancelDesktopSearchRequest: function () {
        var state = this.desktopSearch;
        if (!state) return;
        clearTimeout(state.timer);
        state.request?.abort();
        state.requestId++;
        state.form.classList.remove('loading');
        state.predictive.classList.remove('loading');
      },

      resetDesktopSearchSelection: function () {
        var state = this.desktopSearch;
        state.results.querySelectorAll('[aria-selected="true"]').forEach(function (option) {
          option.setAttribute('aria-selected', 'false');
        });
        state.input.removeAttribute('aria-activedescendant');
      },

      openDesktopSearch: function () {
        var state = this.desktopSearch;
        state.popup.classList.add('popup-search-show');
        state.input.setAttribute('aria-expanded', 'true');
      },

      closeDesktopSearch: function () {
        var state = this.desktopSearch;
        if (!state) return;
        this.cancelDesktopSearchRequest();
        this.resetDesktopSearchSelection();
        state.popup.classList.remove('popup-search-show');
        state.input.setAttribute('aria-expanded', 'false');
      },

      restoreDesktopSearchDefaults: function () {
        var state = this.desktopSearch;
        if (state.showingResults) state.results.replaceChildren(state.defaults);
        state.showingResults = false;
        state.predictive.classList.remove('results');
        this.resetDesktopSearchSelection();
      },

      moveDesktopSearchSelection: function (direction) {
        var state = this.desktopSearch;
        if (state.input.getAttribute('aria-expanded') !== 'true') {
          this.refreshDesktopSearch();
          return;
        }
        var choices = Array.from(state.results.querySelectorAll('[role="option"]'));
        if (!choices.length) return;
        var current = choices.findIndex(function (option) { return option.getAttribute('aria-selected') === 'true'; });
        var next = current < 0 ? (direction > 0 ? 0 : choices.length - 1) : (current + direction + choices.length) % choices.length;
        this.resetDesktopSearchSelection();
        choices[next].setAttribute('aria-selected', 'true');
        state.input.setAttribute('aria-activedescendant', choices[next].id);
        choices[next].scrollIntoView({ block: 'nearest' });
      },

      refreshDesktopSearch: async function () {
        var state = this.desktopSearch;
        this.cancelDesktopSearchRequest();
        var term = state.input.value.trim();
        if (!term) {
          this.restoreDesktopSearchDefaults();
          this.openDesktopSearch();
          return;
        }
        var requestId = state.requestId;
        var markup = state.cache.get(term);
        this.openDesktopSearch();
        if (!markup) {
          state.request = new AbortController();
          state.form.classList.add('loading');
          state.predictive.classList.add('loading');
          var params = new URLSearchParams({
            q: term, 'resources[options][prefix]': 'last',
            'resources[options][unavailable_products]': 'last',
            'resources[type]': 'query,product,page,article', 'resources[limit]': '4',
            'resources[limit_scope]': 'each', section_id: 'predictive-search-results'
          });
          try {
            var response = await fetch(routes.predictive_search_url + '?' + params, { signal: state.request.signal });
            if (!response.ok) throw new Error('Unable to load search suggestions');
            var html = new DOMParser().parseFromString(await response.text(), 'text/html');
            var section = html.getElementById('shopify-section-predictive-search-results');
            // Section Rendering styles can live outside the section wrapper.
            if (section) html.querySelectorAll('style[data-section-stylesheet]').forEach(function (style) {
              if (!section.contains(style)) section.prepend(style);
            });
            markup = section ? section.innerHTML : html.body.innerHTML;
          } catch (error) {
            if (error.name !== 'AbortError' && requestId === state.requestId) {
              this.restoreDesktopSearchDefaults();
              this.closeDesktopSearch();
            }
            return;
          } finally {
            if (requestId === state.requestId) {
              state.form.classList.remove('loading');
              state.predictive.classList.remove('loading');
            }
          }
        }
        if (requestId !== state.requestId || state.input.value.trim() !== term) return;
        if (!markup?.trim()) {
          this.restoreDesktopSearchDefaults();
          this.closeDesktopSearch();
          return;
        }
        state.cache.set(term, markup);
        if (state.cache.size > 50) state.cache.delete(state.cache.keys().next().value);
        if (!state.showingResults) {
          while (state.results.firstChild) state.defaults.appendChild(state.results.firstChild);
        }
        state.showingResults = true;
        state.results.innerHTML = markup;
        state.results.querySelectorAll('[role="option"]').forEach(function (option, index) {
          option.id = 'site-header-desktop-option-' + index;
        });
        state.predictive.classList.add('results');
        this.resetDesktopSearchSelection();
      },

      bindDesktopSearchClear: function () {
        var self = this;
        var desktopSearch = this.sectionRoot.querySelector('.site-header__desktop-search');
        if (!desktopSearch) return;

        var searchForm = desktopSearch.querySelector('#search_mini_form');
        var searchInput = desktopSearch.querySelector('.search__input');
        var clearBtn = desktopSearch.querySelector('.search__clear');
        var searchButton = desktopSearch.querySelector('.search__button');

        if (!searchInput || !clearBtn) return;

        this.initializeRotatingSearchPlaceholder(searchInput);

        if (searchForm) {
          searchForm.addEventListener('submit', function (event) {
            self.handleSearchFormSubmit(event, searchInput);
          }, true);
        }

        if (searchButton) {
          searchButton.addEventListener('click', function (event) {
            event.stopPropagation();
          });
        }

        // 清除按钮点击事件
        clearBtn.addEventListener('click', function () {
          searchInput.value = '';
          searchInput.focus();
          clearBtn.hidden = true;
          self.syncSearchInputValueState(searchInput);

          // 触发input事件以更新搜索结果
          var inputEvent = new Event('input', { bubbles: true });
          searchInput.dispatchEvent(inputEvent);
        });

        // 监听输入框变化
        searchInput.addEventListener('input', function () {
          var hasValue = searchInput.value.trim().length > 0;
          clearBtn.hidden = !hasValue;
          self.syncSearchInputValueState(searchInput);
        });

        clearBtn.hidden = searchInput.value.trim().length === 0;
        this.syncSearchInputValueState(searchInput);
      },

      syncSearchInputValueState: function (searchInput) {
        if (!searchInput) return;
        searchInput.classList.toggle('has-value', searchInput.value.trim().length > 0);
      },

      initializeRotatingSearchPlaceholder: function (searchInput) {
        if (!searchInput || searchInput.dataset.placeholderRotationBound === 'true') return;

        var placeholders = this.parseRotatingPlaceholderList(searchInput.dataset.rotatingPlaceholders);
        var defaultPlaceholder = searchInput.dataset.placeholderDefault || searchInput.getAttribute('placeholder') || 'Search';
        var rotator = this.createRotatingPlaceholderElement(searchInput, defaultPlaceholder);

        searchInput.dataset.placeholderRotationBound = 'true';
        searchInput._themeRotatingPlaceholders = placeholders;
        searchInput._themePlaceholderDefault = defaultPlaceholder;
        searchInput._themePlaceholderIndex = 0;
        searchInput._themePlaceholderTimer = null;
        searchInput._themePlaceholderRotator = rotator;
        searchInput._themePlaceholderAnimationTimer = null;

        this.syncSearchInputValueState(searchInput);
        this.updateRotatingSearchPlaceholder(searchInput, true, false);
        this.toggleRotatingSearchPlaceholder(searchInput);

        searchInput.addEventListener('focus', this.handleRotatingSearchPlaceholderFocus.bind(this, searchInput));
        searchInput.addEventListener('blur', this.toggleRotatingSearchPlaceholder.bind(this, searchInput));
        searchInput.addEventListener('input', this.toggleRotatingSearchPlaceholder.bind(this, searchInput));

      },

      createRotatingPlaceholderElement: function (searchInput, placeholderText) {
        if (!searchInput || !searchInput.parentNode) return null;

        var existingRotator = searchInput.parentNode.querySelector('.search-placeholder-rotator');
        if (existingRotator) {
          existingRotator.textContent = placeholderText || '';
          return existingRotator;
        }

        var rotator = document.createElement('span');
        rotator.className = 'search-placeholder-rotator';
        rotator.setAttribute('aria-hidden', 'true');
        rotator.textContent = placeholderText || '';
        searchInput.parentNode.appendChild(rotator);

        return rotator;
      },

      parseRotatingPlaceholderList: function (rawValue) {
        if (!rawValue) return [];

        try {
          var parsed = JSON.parse(rawValue);
          if (!Array.isArray(parsed)) return [];

          return parsed
            .map(function (item) {
              return String(item || '').trim();
            })
            .filter(function (item) {
              return item.length > 0;
            });
        } catch (error) {
          return [];
        }
      },

      updateRotatingSearchPlaceholder: function (searchInput, resetToFirst, animateTransition) {
        if (!searchInput) return;

        var placeholders = searchInput._themeRotatingPlaceholders || [];
        var defaultPlaceholder = searchInput._themePlaceholderDefault || 'Search';
        var rotator = searchInput._themePlaceholderRotator || null;

        if (!placeholders.length) {
          searchInput.setAttribute('placeholder', defaultPlaceholder);
          if (rotator) {
            rotator.textContent = defaultPlaceholder;
          }
          return;
        }

        if (resetToFirst || typeof searchInput._themePlaceholderIndex !== 'number') {
          searchInput._themePlaceholderIndex = 0;
        }

        var nextPlaceholder = placeholders[searchInput._themePlaceholderIndex] || defaultPlaceholder;
        searchInput.setAttribute('placeholder', nextPlaceholder);
        this.setRotatingPlaceholderText(searchInput, nextPlaceholder, Boolean(animateTransition));
      },

      setRotatingPlaceholderText: function (searchInput, nextPlaceholder, animateTransition) {
        var rotator = searchInput ? searchInput._themePlaceholderRotator : null;
        if (!rotator) return;

        if (searchInput._themePlaceholderAnimationTimer) {
          window.clearTimeout(searchInput._themePlaceholderAnimationTimer);
          searchInput._themePlaceholderAnimationTimer = null;
        }

        rotator.classList.remove('is-entering', 'is-exiting');

        if (!animateTransition || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          rotator.textContent = nextPlaceholder;
          return;
        }

        rotator.style.removeProperty('transition');
        rotator.classList.add('is-exiting');
        searchInput._themePlaceholderAnimationTimer = window.setTimeout(function () {
          rotator.textContent = nextPlaceholder;
          rotator.classList.remove('is-exiting');
          rotator.classList.add('is-entering');

          searchInput._themePlaceholderAnimationTimer = window.setTimeout(function () {
            rotator.classList.remove('is-entering');
            searchInput._themePlaceholderAnimationTimer = null;
          }, 260);
        }, 120);
      },

      setRotatingPlaceholderVisibility: function (searchInput, isHidden, immediate) {
        var rotator = searchInput ? searchInput._themePlaceholderRotator : null;
        if (!rotator) return;

        if (searchInput._themePlaceholderAnimationTimer) {
          window.clearTimeout(searchInput._themePlaceholderAnimationTimer);
          searchInput._themePlaceholderAnimationTimer = null;
        }

        rotator.classList.remove('is-entering', 'is-exiting');

        if (immediate) {
          // 输入和清空时立即切换；真正轮换文案时再恢复动画，避免读取布局强制刷新。
          rotator.style.transition = 'none';
        } else {
          rotator.style.removeProperty('transition');
        }

        rotator.classList.toggle('is-hidden', Boolean(isHidden));
      },

      startRotatingSearchPlaceholder: function (searchInput) {
        var self = this;
        var placeholders = searchInput ? searchInput._themeRotatingPlaceholders : [];
        if (!searchInput || placeholders.length < 2 || searchInput._themePlaceholderTimer) return;

        searchInput._themePlaceholderTimer = window.setInterval(function () {
          if (document.activeElement === searchInput || searchInput.value.trim().length > 0) {
            return;
          }

          searchInput._themePlaceholderIndex = (searchInput._themePlaceholderIndex + 1) % placeholders.length;
          self.updateRotatingSearchPlaceholder(searchInput, false, true);
        }, this.rotatingPlaceholderInterval);
      },

      stopRotatingSearchPlaceholder: function (searchInput) {
        if (!searchInput || !searchInput._themePlaceholderTimer) return;

        window.clearInterval(searchInput._themePlaceholderTimer);
        searchInput._themePlaceholderTimer = null;
      },

      handleRotatingSearchPlaceholderFocus: function (searchInput) {
        this.stopRotatingSearchPlaceholder(searchInput);

        if (searchInput && !searchInput.value.trim().length) {
          this.setRotatingPlaceholderVisibility(searchInput, false, true);
        }
      },

      toggleRotatingSearchPlaceholder: function (searchInput) {
        if (!searchInput) return;

        if (searchInput.value.trim().length > 0) {
          this.stopRotatingSearchPlaceholder(searchInput);
          this.setRotatingPlaceholderVisibility(searchInput, true, true);
          return;
        }

        this.updateRotatingSearchPlaceholder(searchInput, false, false);
        this.setRotatingPlaceholderVisibility(searchInput, false, true);

        if (document.activeElement === searchInput) {
          this.stopRotatingSearchPlaceholder(searchInput);
          return;
        }

        this.startRotatingSearchPlaceholder(searchInput);
      },

      getEffectiveSearchTerm: function (searchInput) {
        if (!searchInput) return '';

        var inputValue = searchInput.value.trim();
        if (inputValue.length > 0) return inputValue;

        var currentPlaceholder = searchInput.getAttribute('placeholder') || searchInput._themePlaceholderDefault || '';
        return currentPlaceholder.trim();
      },

      handleSearchFormSubmit: function (event, searchInput) {
        var form = event && event.currentTarget ? event.currentTarget : searchInput && searchInput.form;
        var searchTerm = this.getEffectiveSearchTerm(searchInput);

        if (!form || !searchTerm.length) {
          event.preventDefault();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          } else {
            event.stopPropagation();
          }
          return;
        }

        event.preventDefault();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        } else {
          event.stopPropagation();
        }

        if (searchInput === this.desktopSearch?.input && searchInput.getAttribute('aria-expanded') === 'true') {
          var selected = this.desktopSearch.results.querySelector('[aria-selected="true"]');
          var link = selected?.matches('a, button') ? selected : selected?.querySelector('a, button');
          if (link) {
            link.click();
            return;
          }
        }
        this.navigateSearchForm(form, searchInput, searchTerm);
      },

      navigateSearchForm: function (form, searchInput, searchTerm) {
        if (!form) return;

        var formAction = form.getAttribute('action') || routes.search_url || window.location.pathname;
        var params = new URLSearchParams();
        var formData = new FormData(form);

        formData.forEach(function (value, key) {
          params.append(key, value);
        });

        params.set(searchInput && searchInput.name ? searchInput.name : 'q', searchTerm);
        window.location.assign(formAction + '?' + params.toString());
      },

      observeRecentlyViewedBlock: function (block) {
        if (!block || block.dataset.themeObserved === 'true') return;

        var recentProducts = block.querySelector('recently-viewed-products');
        if (!recentProducts) return;

        block.dataset.themeObserved = 'true';

        var self = this;
        var recentObserver = null;
        var syncRecentlyViewedState = function () {
          var currentRecentProducts = block.querySelector('recently-viewed-products');
          var hasProducts =
            currentRecentProducts &&
            currentRecentProducts.querySelector('.site-header__recent-products-grid') &&
            currentRecentProducts.querySelector('.site-header__recent-products-grid').children.length > 0;

          block.classList.toggle('is-hidden', !hasProducts);
          if (hasProducts || !currentRecentProducts) {
            recentObserver?.disconnect();
            self.recentObservers?.delete(recentObserver);
            return true;
          }
          return false;
        };

        if (syncRecentlyViewedState()) return;

        recentObserver = new MutationObserver(syncRecentlyViewedState);
        this.recentObservers ||= new Set();
        this.recentObservers.add(recentObserver);
        recentObserver.observe(block, { childList: true, subtree: true });
      },

      syncCartCountBadges: function () {
        if (!this.sectionRoot) return;

        if (this.cartCountObserver) this.cartCountObserver.disconnect();
        this.cartCountObserver = null;

        var countElements = this.sectionRoot.querySelectorAll('.header__minicart h-count .h-count');
        if (!countElements.length) return;

        var syncVisibility = function (countElement) {
          var countText = countElement.textContent.split('\n')[0].trim();
          var display = countText === '0' || countText === '' ? 'none' : 'inline-flex';
          if (countElement.style.display !== display) countElement.style.display = display;
        };

        countElements.forEach(syncVisibility);

        var observedCounts = new Set(countElements);
        // 两端角标共享监听器，同一批更新只回调一次，并去重发生变化的角标。
        var countObserver = new MutationObserver(function (mutations) {
          var changedCounts = new Set();
          mutations.forEach(function (mutation) {
            var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
            var countElement = target && target.closest('.cart-count.h-count');
            if (observedCounts.has(countElement)) changedCounts.add(countElement);
          });
          changedCounts.forEach(syncVisibility);
        });

        this.cartCountObserver = countObserver;
        countElements.forEach(function (countElement) {
          countObserver.observe(countElement, { childList: true, characterData: true, subtree: true });
        });
      },

      initDesktopActionHover: function () {
        var self = this;
        if (
          window.matchMedia('(max-width: 1279.98px)').matches ||
          window.matchMedia('(hover: none)').matches ||
          window.matchMedia('(pointer: coarse)').matches
        ) {
          return;
        }

        var actionFlyouts = this.sectionRoot.querySelectorAll('.site-header__desktop-actions [data-action-flyout]');
        if (!actionFlyouts.length) return;

        function getActionId(flyout, link) {
          if (flyout && flyout.dataset.actionFlyout) return flyout.dataset.actionFlyout;
          if (!link) return 'action';

          var actionClass = Array.from(link.classList).find(function (className) {
            return className.indexOf('site-header__action-link--') === 0;
          });

          if (!actionClass) return 'action';
          return actionClass.replace('site-header__action-link--', '');
        }

        actionFlyouts.forEach(function (flyout) {
          var link = flyout.querySelector('.site-header__action-link');
          var popup = flyout.querySelector('.site-tooltip__panel');
          var actionId = getActionId(flyout, link);
          var hideTimer = null;

          if (!link || flyout.dataset.hoverBound === 'true') return;
          flyout.dataset.hoverBound = 'true';

          function clearHideTimer() {
            if (!hideTimer) return;
            window.clearTimeout(hideTimer);
            hideTimer = null;
          }

          function openFlyout() {
            clearHideTimer();
            self.setDesktopActionHoverState(flyout, link, popup, true, actionId);
          }

          function closeFlyout() {
            clearHideTimer();
            hideTimer = window.setTimeout(function () {
              self.setDesktopActionHoverState(flyout, link, popup, false, actionId);
            }, 90);
          }

          flyout.addEventListener('mouseenter', openFlyout);
          flyout.addEventListener('mouseleave', closeFlyout);

          flyout.addEventListener('focusin', function () {
            openFlyout();
            link.classList.add('is-focused-visible');
            link.dispatchEvent(
              new CustomEvent('site-header:icon-focus', {
                bubbles: true,
                detail: { id: actionId },
              })
            );
          });

          flyout.addEventListener('focusout', function (event) {
            if (flyout.contains(event.relatedTarget)) return;

            link.classList.remove('is-focused-visible');
            closeFlyout();
            link.dispatchEvent(
              new CustomEvent('site-header:icon-blur', {
                bubbles: true,
                detail: { id: actionId },
              })
            );
          });

          flyout.addEventListener('keydown', function (event) {
            if (event.key !== 'Escape') return;

            clearHideTimer();
            self.setDesktopActionHoverState(flyout, link, popup, false, actionId);
            link.focus();
          });
        });
      },

      setDesktopActionHoverState: function (flyout, link, popup, isHovered, actionId) {
        if (!flyout || !link) return;

        flyout.classList.toggle('is-open', isHovered);
        link.classList.toggle('is-hovered', isHovered);
        link.setAttribute('aria-expanded', isHovered ? 'true' : 'false');

        if (popup) {
          popup.setAttribute('aria-hidden', isHovered ? 'false' : 'true');
        }

        link.dispatchEvent(
          new CustomEvent(isHovered ? 'site-header:icon-hover-enter' : 'site-header:icon-hover-leave', {
            bubbles: true,
            detail: { id: actionId },
          })
        );
      },

      initMegaMenuHover: function () {
        var navItems = Array.from(this.sectionRoot.querySelectorAll('.site-header__nav-item'));
        var megaMenuWrapper = this.sectionRoot.querySelector('.site-header__mega-menu-wrapper');
        if (!navItems.length || !megaMenuWrapper) return;

        var panels = Array.from(megaMenuWrapper.querySelectorAll('.mega-menu__panel'));
        var listenerOptions = { signal: this.globalEvents.signal };
        var activePanel = null;
        var activeLink = null;
        var hideTimeout = null;
        var entries = navItems.map(function (item) {
          var link = item.querySelector('.site-header__nav-link');
          var index = item.getAttribute('data-menu-index');
          var title = item.getAttribute('data-menu-title');
          var panel = panels.find(function (candidate) {
            return index !== null
              ? candidate.getAttribute('data-menu-index') === index
              : candidate.getAttribute('data-menu-title') === title;
          });
          if (link && panel) {
            panel.id = panel.id || 'header-submenu-' + item.closest('[id^="shopify-section-"]').id + '-' + index;
            link.setAttribute('aria-controls', panel.id);
            link.setAttribute('aria-expanded', 'false');
          }
          return { item: item, link: link, panel: panel };
        });

        function positionPlainTextPanel(panel, item) {
          if (!panel || !item || !panel.classList.contains('mega-menu__panel--plain-text')) return;

          var wrapperRect = megaMenuWrapper.getBoundingClientRect();
          var itemRect = item.getBoundingClientRect();
          var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
          var panelWidth = Math.min(panel.getBoundingClientRect().width || viewportWidth - 32, viewportWidth - 32);
          var idealLeft = itemRect.left - wrapperRect.left;
          var maxLeft = Math.max(16, wrapperRect.width - panelWidth - 16);
          var left = Math.min(Math.max(16, idealLeft), maxLeft);

          panel.style.setProperty('--plain-text-left', left + 'px');
        }

        function clearHideTimer() {
          window.clearTimeout(hideTimeout);
          hideTimeout = null;
        }

        function hideAllPanelsImmediate() {
          clearHideTimer();
          panels.forEach(function (panel) { panel.classList.remove('is-active'); });
          entries.forEach(function (entry) {
            if (entry.link && entry.panel) entry.link.setAttribute('aria-expanded', 'false');
          });
          activePanel = null;
          activeLink = null;
        }

        function showPanel(entry) {
          hideAllPanelsImmediate();
          if (!entry.panel || !entry.link) return;
          activePanel = entry.panel;
          activeLink = entry.link;
          activePanel.classList.add('is-active');
          activeLink.setAttribute('aria-expanded', 'true');
          positionPlainTextPanel(activePanel, entry.item);
        }

        function panelLinks(panel) {
          return Array.from(panel.querySelectorAll('a[href], button, [tabindex]')).filter(function (link) {
            return link.tabIndex >= 0 && !link.matches(':disabled') && link.getClientRects().length
              && window.getComputedStyle(link).visibility === 'visible';
          });
        }

        function hideAfterPointerExit() {
          clearHideTimer();
          hideTimeout = window.setTimeout(function () {
            if (activeLink === document.activeElement || activePanel?.contains(document.activeElement)) return;
            hideAllPanelsImmediate();
          }, 150);
        }

        function closeWhenFocusLeaves(event) {
          var target = event.relatedTarget;
          if (megaMenuWrapper.contains(target) || entries.some(function (entry) { return entry.link === target; })) return;
          hideAllPanelsImmediate();
        }

        entries.forEach(function (entry, index) {
          var item = entry.item;
          var link = entry.link;
          item.addEventListener('mouseenter', function () { showPanel(entry); }, listenerOptions);
          item.addEventListener('mouseleave', hideAfterPointerExit, listenerOptions);
          if (!link) return;
          link.addEventListener('focus', function () { showPanel(entry); }, listenerOptions);
          link.addEventListener('blur', closeWhenFocusLeaves, listenerOptions);
          link.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
              hideAllPanelsImmediate();
              return;
            }
            if (!entry.panel) return;
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || (event.key === 'Tab' && !event.shiftKey)) {
              if (activePanel !== entry.panel && event.key === 'Tab') return;
              showPanel(entry);
              var links = panelLinks(entry.panel);
              var target = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
              if (target) { event.preventDefault(); target.focus(); }
            }
          }, listenerOptions);
          if (!entry.panel) return;
          entry.panel.addEventListener('keydown', function (event) {
            var links = panelLinks(entry.panel);
            if (event.key === 'Escape' || (event.key === 'Tab' && event.shiftKey && document.activeElement === links[0])) {
              event.preventDefault();
              link.focus({ preventScroll: true });
              if (event.key === 'Escape') hideAllPanelsImmediate();
            } else if (event.key === 'Tab' && !event.shiftKey && document.activeElement === links[links.length - 1]) {
              var nextLink = entries[index + 1]?.link;
              if (nextLink) {
                event.preventDefault();
                nextLink.focus();
              } else {
                // The panel follows all primary links in DOM order; resume after the last primary link.
                link.focus({ preventScroll: true });
                hideAllPanelsImmediate();
              }
            }
          }, listenerOptions);
        });

        megaMenuWrapper.addEventListener('mouseenter', clearHideTimer, listenerOptions);
        megaMenuWrapper.addEventListener('mouseleave', hideAfterPointerExit, listenerOptions);
        megaMenuWrapper.addEventListener('focusout', closeWhenFocusLeaves, listenerOptions);
        this.globalEvents.signal.addEventListener('abort', clearHideTimer, { once: true });
      },

      initMegaMenuPreviewHover: function () {
        var megaMenuWrapper = this.sectionRoot.querySelector('.site-header__mega-menu-wrapper');
        if (!megaMenuWrapper) return;

        var panels = megaMenuWrapper.querySelectorAll('.mega-menu__panel');

        panels.forEach(function (panel) {
          var triggers = panel.querySelectorAll('[data-preview-target]');
          var previews = panel.querySelectorAll('[data-preview-id]');
          if (!triggers.length || !previews.length) return;

          function activatePreview(previewId) {
            triggers.forEach(function (trigger) {
              trigger.classList.toggle('is-active', trigger.getAttribute('data-preview-target') === previewId);
            });

            previews.forEach(function (preview) {
              preview.classList.toggle('is-active', preview.getAttribute('data-preview-id') === previewId);
            });
          }

          triggers.forEach(function (trigger) {
            trigger.addEventListener('mouseenter', function () {
              activatePreview(trigger.getAttribute('data-preview-target'));
            });

            trigger.addEventListener('focus', function () {
              activatePreview(trigger.getAttribute('data-preview-target'));
            });
          });

          activatePreview(triggers[0].getAttribute('data-preview-target'));
        });
      },
    };

    // The header section is present on every page. Reinitialize after theme-editor replacements.
    function mountSiteHeader() {
      if (siteHeader.sectionWrapper && !siteHeader.sectionWrapper.isConnected) siteHeader.dispose();
      siteHeader.init();
      if (siteHeader.sectionWrapper?.isConnected) window.siteHeader = siteHeader;
    }

    window.siteHeaderBootstrap = { init: mountSiteHeader };
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target?.querySelector('.sec__header')) mountSiteHeader();
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountSiteHeader, { once: true });
    } else {
      mountSiteHeader();
    }
  })();
